export function formatFirstLastInitial(first: string | undefined | null, last: string | undefined | null): string {
  const firstName = first ?? '';
  const lastInitial = last ? ` ${last[0]}.` : '';

  return `${firstName}${lastInitial}`.trim();
}
